const Spinner = ({
  "data-testid": testId,
}: { "data-testid"?: string } = {}) => {
  return (
    <div
      data-testid={testId}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(255,255,255,0.7)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          width: 48,
          height: 48,
          border: "6px solid #e0e0e0",
          borderTop: "6px solid #1976d2",
          borderRadius: "50%",
          animation: "spin 1s linear infinite",
          marginBottom: 16,
        }}
      />
      <div style={{ color: "#1976d2", fontWeight: 500, fontSize: 18 }}>
        Načítavam…
      </div>
      {/* Spinner keyframes */}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default Spinner;
